export function battery(
  reading: number
  // scale: number,
  // offset: number,
  // frequency: number
): number {
  return reading / 512.0
}
